class ContentApi {

    constructor(seamApi) {
        this.api = seamApi;
    }

    async index(params) {
        return this.api.handleResponse(async () => {
            const response = await this.api.get('/content-list', { ...params });

            return response.data;
        });
    }

    async list(
        page = 1,
        perPage = 20,
        contentTypeIds = [],
        tags = [],
        orderBy = 'published',
        orderDirection = 'asc'
    ) {
        return this.api.handleResponse(async () => {

            const response = await this.api.get('/content-list', {
                page,
                per_page: perPage,
                content_type_ids: contentTypeIds,
                tags,
                distribution_id : config.distribution_id,
                order_by : orderBy,
                order_direction : orderDirection
            });

            return response.data;
        });
    }

    async page(params) {
        return this.api.handleResponse(async () => {
            const response = await this.api.get('/content-page', { ...params });
            return response.data;
        });
    }

    async search(term, contentTypeIds=  [], tags = [], cancelHandler = () => {}) {
        return this.api.handleResponse(async () => {
           const response = await this.api.post('/page-search', {
                  term : term,
                  distribution_id : config.distribution_id,
                  filters : {
                      content_type_ids : contentTypeIds,
                      tags : tags
                  }

           }, this.api.defaultValidationHandler, cancelHandler);
            return response.data;
        });

    }

}

export default ContentApi;
